import { updateTrackedUsers } from '../../redux/db/actions';
import store from '../../redux/store';
import { UserRow } from '../types';
import { parsePostgresDate } from '../util';
import { Stream } from './Stream';
import { VITE_FORGE_URL } from '../../constants';

export class TrackedUserStream extends Stream<UserRow> {
	constructor(trackedUserIds: string[]) {
		const url = VITE_FORGE_URL + '/electric/users';
		const params = { userIds: trackedUserIds.join(',') };

		const onError = (error: Error) => {
			console.error('Tracked users stream error:', error);
			store.dispatch(updateTrackedUsers([]));
		};

		super(url, params, onError);
	}

	onShapeData(rows: UserRow[]) {
		const users = rows.map((userRow) => ({
			id: userRow.id,
			displayName: userRow.display_name,
			metadata: userRow.metadata,
			createdAt: parsePostgresDate(userRow.created_at),
			writeId: userRow.write_id,
		}));
		store.dispatch(updateTrackedUsers(users));
	}

	onStreamMessages(_messages: Array<unknown>) {
		// No optimistic updates needed since tracked users are read-only
	}
}
